import Icon from "@mui/icons-material/FactCheck";

export default function TestRunnerIcon(props) {
	return <Icon color={props.color} />;
}